import { Button } from "primereact/button";

export default function ModulePopConfirm({ prePopOption, closePrePop }) {
  return (
    <>
      <div className="mx-3">
        {/* <div className="text-2xl text-center font-bold mb-4">
          {intl.formatMessage({
            id: "app.info.confirm_continue_import",
          })}
        </div> */}

        <div className="text-center mb-4">
          <div className="inline-flex align-items-center justify-content-center w-5rem h-5rem text-6xl text-white border-circle bg-red-500">
            ！
          </div>
        </div>

        <div className="text-xl font-bold white-space-prewrap line-height-4 max-h-15rem overflow-y-auto">
          {prePopOption.data.msg}
        </div>

        <div className="text-center mt-5">
          <Button
            className="p-button-secondary w-auto px-4"
            type="button"
            label="關閉"
            onClick={() => closePrePop({ type: prePopOption.type })}
          />
        </div>
      </div>
    </>
  );
}
